/**
 * Rock Cerchar photo workflow (report sample-before / sample-after page).
 *
 * Reuses the free-form category model from the triaxial / BTS photos tab
 * (Photo.Stage = category id, Photo.Position = 1-based index). Cerchar has a
 * single specimen, so just two categories: before vs after testing.
 *
 * The category ids MUST match the backend CERCHAR_RULER_STAGES set
 * (backend/src/services/photoBatchService.ts) — those stage ids drive the
 * automatic ruler crop on upload and the report's photo fetch.
 *
 * The report consumes the FIRST photo (lowest Position) of each category.
 */

export type CercharPhotoCategoryId = 'cerchar-before' | 'cerchar-after';

export interface CercharPhotoCategory {
  id: CercharPhotoCategoryId;
  label: string;
  description: string;
}

/** Category list + report captions for the Cerchar specimen. */
export const cercharPhotoCategories = (): CercharPhotoCategory[] => [
  { id: 'cerchar-before', label: 'Sample Before Testing', description: 'The sample prior to scratching.' },
  { id: 'cerchar-after', label: 'Sample After Testing', description: 'The sample after the scratch tests.' },
];
